import { LocalDateTime3vqv9moe7clf4 as LocalDateTime } from './LocalDateTime.mjs';
import { KProperty02ce7r476m8633 as KProperty0 } from '../../../kotlin-kotlin-stdlib/kotlin/reflect/KPropertyJs.mjs';
import {
  getPropertyCallableRef3hckxc0xueiaj as getPropertyCallableRef,
  constructCallableReference23y65rf941mch as constructCallableReference,
} from '../../../kotlin-kotlin-stdlib/kotlin/js/reflectRuntime.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { IllegalArgumentException2asla15b5jaob as IllegalArgumentException } from '../../../kotlin-kotlin-stdlib/kotlin/exceptions.mjs';
import {
  toString1pkumu07cwy4m as toString,
  createThis2j2avj17cvnv2 as createThis,
} from '../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { Unit_instance3kz1zqli6gr1r as Unit_instance } from '../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import {
  fromInt2ii0rejb1w62w as fromInt,
  multiply2k9eolhnz1bjv as multiply,
  dividelr0uqtdj497z as divide,
  convertToInty04h231mmjoh as convertToInt,
  numberToLong2pakxeg38estk as numberToLong,
  subtract2orl8z9upxd9l as subtract,
  shiftRightUnsigned1ga7wnvbv2qur as shiftRightUnsigned,
  add2suhfggl4zvkk as add,
} from '../../../kotlin-kotlin-stdlib/kotlin/js/internal/longAsBigInt/longAsBigInt.mjs';
import { LocalTimeSerializer_getInstance1j419gm07xrpf as LocalTimeSerializer_getInstance } from './serializers/LocalTimeSerializers.mjs';
import {
  initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion,
  initMetadataForObject1cxne3s9w65el as initMetadataForObject,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
} from '../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import {
  get_ISO_TIME31n00f6uljtbs as get_ISO_TIME,
  Companion_instance3or33wnaitl75 as Companion_instance,
  Companion_getInstance2adk18we47186 as Companion_getInstance,
} from './format/LocalTimeFormat.mjs';
import { compareTo3ankvs086tmwq as compareTo } from '../../../kotlin-kotlin-stdlib/kotlin/js/compareTo.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { Comparable198qfk8pnblz0 as Comparable } from '../../../kotlin-kotlin-stdlib/kotlin/Comparable.mjs';
import { _Char___init__impl__6a9atxrzocepzq3zgi as _Char___init__impl__6a9atx } from '../../../kotlin-kotlin-stdlib/kotlin/Char.mjs';
import {
  char1r4ssccmdfesy as char,
  optional3j6ywsx1pxeh6 as optional,
  secondFractionInternalr53tad5c19e9 as secondFractionInternal,
} from './format/DateTimeFormatBuilder.mjs';
import { lazy2hsh8ze7j6ikd as lazy } from '../../../kotlin-kotlin-stdlib/kotlin/kotlin.mjs';
import { SerializableWithd2dap36updxd as SerializableWith } from '../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/SerializersJs.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
//endregion
function getIsoTimeFormat() {
  return Formats_instance.get_ISO_18jrwk_k$();
}
function format(_this__u8e3s4, format) {
  return format.format_l1mq08_k$(_this__u8e3s4);
}
function atDate(_this__u8e3s4, year, month, day) {
  return LocalDateTime().new_kotlinx_datetime_LocalDateTime_d9xan1_k$(year, month, day, _this__u8e3s4.hour_1, _this__u8e3s4.minute_1, _this__u8e3s4.second_1, _this__u8e3s4.nanosecond_1);
}
function get_ISO_TIME_OPTIONAL_SECONDS_TRAILING_ZEROS() {
  _init_properties_LocalTime_kt__nmhi56();
  var tmp0 = ISO_TIME_OPTIONAL_SECONDS_TRAILING_ZEROS$delegate;
  var tmp = KProperty0();
  // Inline function 'kotlin.getValue' call
  getPropertyCallableRef('ISO_TIME_OPTIONAL_SECONDS_TRAILING_ZEROS', 0, tmp, _get_ISO_TIME_OPTIONAL_SECONDS_TRAILING_ZEROS_$ref_fmwpvv(), null);
  return tmp0.get_value_j01efc_k$();
}
var ISO_TIME_OPTIONAL_SECONDS_TRAILING_ZEROS$delegate;
var CompanionClass;
function Companion() {
  if (CompanionClass === VOID) {
    class $ {
      constructor() {
        Companion_instance_0 = this;
        this.MIN_1 = LocalTime().new_kotlinx_datetime_LocalTime_huq53_k$(0, 0, 0, 0);
        this.MAX_1 = LocalTime().new_kotlinx_datetime_LocalTime_huq53_k$(23, 59, 59, 999999999);
      }
      parse_keg146_k$(input, format) {
        return format.parse_xovy9i_k$(input);
      }
      parse$default_id2jrv_k$(input, format, $super) {
        format = format === VOID ? getIsoTimeFormat() : format;
        return $super === VOID ? this.parse_keg146_k$(input, format) : $super.parse_keg146_k$.call(this, input, format);
      }
      ofSecondOfDay_9u5rnn_k$(secondOfDay, nanoOfSecond) {
        // Inline function 'kotlin.require' call
        if (!(0 <= secondOfDay ? secondOfDay < 86400 : false)) {
          var message = 'Invalid time: secondOfDay must be between 0 and 86400, got ' + secondOfDay;
          throw IllegalArgumentException().new_kotlin_IllegalArgumentException_sfqr8_k$(toString(message));
        }
        // Inline function 'kotlin.require' call
        if (!(0 <= nanoOfSecond ? nanoOfSecond < 1000000000 : false)) {
          var message_0 = 'Invalid time: nanosecondOfSecond must be between 0 and 1000000000, got ' + nanoOfSecond;
          throw IllegalArgumentException().new_kotlin_IllegalArgumentException_sfqr8_k$(toString(message_0));
        }
        var hours = secondOfDay / 3600 | 0;
        var secondWithoutHours = secondOfDay - imul(hours, 3600) | 0;
        var minutes = secondWithoutHours / 60 | 0;
        var second = secondWithoutHours - imul(minutes, 60) | 0;
        return LocalTime().new_kotlinx_datetime_LocalTime_r3n6yz_k$(hours, minutes, second, nanoOfSecond, Unit_instance);
      }
      ofNanoOfDay_q9nllz_k$(nanoOfDay) {
        var tmp;
        if (nanoOfDay >= 0n) {
          // Inline function 'kotlin.Long.times' call
          var other = 1000000000;
          tmp = nanoOfDay < multiply(86400n, fromInt(other));
        } else {
          tmp = false;
        }
        // Inline function 'kotlin.require' call
        if (!tmp) {
          var message = 'Invalid time: nanosecondOfDay must be between 0 and 86_400_000_000_000, got ' + nanoOfDay.toString();
          throw IllegalArgumentException().new_kotlin_IllegalArgumentException_sfqr8_k$(toString(message));
        }
        var newNanoOfDay = nanoOfDay;
        var hours = convertToInt(divide(newNanoOfDay, 3600000000000n));
        newNanoOfDay = subtract(newNanoOfDay, multiply(numberToLong(hours), 3600000000000n));
        var minutes = convertToInt(divide(newNanoOfDay, 60000000000n));
        newNanoOfDay = subtract(newNanoOfDay, multiply(numberToLong(minutes), 60000000000n));
        var tmp0 = newNanoOfDay;
        // Inline function 'kotlin.Long.div' call
        var other_0 = 1000000000;
        var tmp$ret$3 = divide(tmp0, fromInt(other_0));
        var seconds = convertToInt(tmp$ret$3);
        var tmp0_0 = newNanoOfDay;
        // Inline function 'kotlin.Long.minus' call
        var other_1 = imul(seconds, 1000000000);
        newNanoOfDay = subtract(tmp0_0, fromInt(other_1));
        return LocalTime().new_kotlinx_datetime_LocalTime_r3n6yz_k$(hours, minutes, seconds, convertToInt(newNanoOfDay), Unit_instance);
      }
      serializer_9w0wvi_k$() {
        return LocalTimeSerializer_getInstance();
      }
    }
    initMetadataForCompanion($);
    CompanionClass = $;
  }
  return CompanionClass;
}
var Companion_instance_0;
function Companion_getInstance_0() {
  if (Companion_instance_0 === VOID)
    new (Companion())();
  return Companion_instance_0;
}
var FormatsClass;
function Formats() {
  if (FormatsClass === VOID) {
    class $ {
      get_ISO_18jrwk_k$() {
        return get_ISO_TIME();
      }
    }
    initMetadataForObject($, 'Formats');
    FormatsClass = $;
  }
  return FormatsClass;
}
var Formats_instance;
function Formats_getInstance() {
  return Formats_instance;
}
function _init_$check_eg57ze(value, lower, upper, str) {
  // Inline function 'kotlin.require' call
  if (!(lower <= value ? value <= upper : false)) {
    var message = 'Invalid time: ' + str + ' must be a number between ' + lower + ' and ' + upper + ', got ' + value;
    throw IllegalArgumentException().new_kotlin_IllegalArgumentException_sfqr8_k$(toString(message));
  }
  return Unit_instance;
}
var LocalTimeClass;
function LocalTime() {
  if (LocalTimeClass === VOID) {
    class $ {
      constructor(hour, minute, second, nanosecond, unit) {
        return new.target.new_kotlinx_datetime_LocalTime_r3n6yz_k$(hour, minute, second, nanosecond, unit);
      }
      static new_kotlinx_datetime_LocalTime_r3n6yz_k$(hour, minute, second, nanosecond, unit) {
        Companion_getInstance_0();
        var $this = createThis(this);
        $this.hour_1 = hour;
        $this.minute_1 = minute;
        $this.second_1 = second;
        $this.nanosecond_1 = nanosecond;
        return $this;
      }
      static new_kotlinx_datetime_LocalTime_huq53_k$(hour, minute, second, nanosecond) {
        Companion_getInstance_0();
        second = second === VOID ? 0 : second;
        nanosecond = nanosecond === VOID ? 0 : nanosecond;
        var $this = this.new_kotlinx_datetime_LocalTime_r3n6yz_k$(hour, minute, second, nanosecond, Unit_instance);
        _init_$check_eg57ze(hour, 0, 23, 'hour');
        _init_$check_eg57ze(minute, 0, 59, 'minute');
        _init_$check_eg57ze(second, 0, 59, 'second');
        _init_$check_eg57ze(nanosecond, 0, 999999999, 'nanosecond');
        return $this;
      }
      compareTo_6io3dl_k$(other) {
        var h = compareTo(this.hour_1, other.hour_1);
        if (!(h === 0)) {
          return h;
        }
        var m = compareTo(this.minute_1, other.minute_1);
        if (!(m === 0)) {
          return m;
        }
        var s = compareTo(this.second_1, other.second_1);
        if (!(s === 0)) {
          return s;
        }
        return compareTo(this.nanosecond_1, other.nanosecond_1);
      }
      compareTo_hpufkf_k$(other) {
        return this.compareTo_6io3dl_k$(other instanceof LocalTime() ? other : THROW_CCE());
      }
      hashCode() {
        var nod = this.toNanosecondOfDay_dywvsy_k$();
        return convertToInt(nod ^ shiftRightUnsigned(nod, 32));
      }
      toSecondOfDay_a2clsa_k$() {
        var total = imul(this.hour_1, 3600);
        total = total + imul(this.minute_1, 60) | 0;
        total = total + this.second_1 | 0;
        return total;
      }
      toNanosecondOfDay_dywvsy_k$() {
        var tmp0 = fromInt(this.hour_1);
        // Inline function 'kotlin.Long.times' call
        var other = 1000000000;
        // Inline function 'kotlin.Long.times' call
        var this_0 = multiply(tmp0, fromInt(other));
        var total = multiply(this_0, fromInt(3600));
        var tmp = total;
        var tmp0_0 = fromInt(this.minute_1);
        // Inline function 'kotlin.Long.times' call
        var other_0 = 1000000000;
        // Inline function 'kotlin.Long.times' call
        var this_1 = multiply(tmp0_0, fromInt(other_0));
        var tmp$ret$3 = multiply(this_1, fromInt(60));
        total = add(tmp, tmp$ret$3);
        var tmp_0 = total;
        var tmp0_1 = fromInt(this.second_1);
        // Inline function 'kotlin.Long.times' call
        var other_1 = 1000000000;
        var tmp$ret$4 = multiply(tmp0_1, fromInt(other_1));
        total = add(tmp_0, tmp$ret$4);
        total = add(total, fromInt(this.nanosecond_1));
        return total;
      }
      toString() {
        return format(this, get_ISO_TIME_OPTIONAL_SECONDS_TRAILING_ZEROS());
      }
      equals(other) {
        var tmp;
        if (other instanceof LocalTime()) {
          tmp = this.compareTo_6io3dl_k$(other) === 0;
        } else {
          tmp = false;
        }
        return tmp;
      }
    }
    initMetadataForClass($, 'LocalTime', VOID, VOID, [Comparable()], VOID, VOID, {0: LocalTimeSerializer_getInstance});
    LocalTimeClass = $;
  }
  return LocalTimeClass;
}
function ISO_TIME_OPTIONAL_SECONDS_TRAILING_ZEROS$delegate$lambda() {
  _init_properties_LocalTime_kt__nmhi56();
  var tmp = Companion_instance;
  return tmp.build_agwrib_k$(ISO_TIME_OPTIONAL_SECONDS_TRAILING_ZEROS$delegate$lambda$lambda);
}
function ISO_TIME_OPTIONAL_SECONDS_TRAILING_ZEROS$delegate$lambda$lambda($this$build) {
  _init_properties_LocalTime_kt__nmhi56();
  $this$build.hour$default_ke0z0o_k$();
  char($this$build, _Char___init__impl__6a9atx(58));
  $this$build.minute$default_r7oarc_k$();
  optional($this$build, VOID, ISO_TIME_OPTIONAL_SECONDS_TRAILING_ZEROS$delegate$lambda$lambda$lambda);
  return Unit_instance;
}
function ISO_TIME_OPTIONAL_SECONDS_TRAILING_ZEROS$delegate$lambda$lambda$lambda($this$optional) {
  _init_properties_LocalTime_kt__nmhi56();
  char($this$optional, _Char___init__impl__6a9atx(58));
  $this$optional.second$default_ix75t4_k$();
  optional($this$optional, VOID, ISO_TIME_OPTIONAL_SECONDS_TRAILING_ZEROS$delegate$lambda$lambda$lambda$lambda);
  return Unit_instance;
}
function ISO_TIME_OPTIONAL_SECONDS_TRAILING_ZEROS$delegate$lambda$lambda$lambda$lambda($this$optional) {
  _init_properties_LocalTime_kt__nmhi56();
  char($this$optional, _Char___init__impl__6a9atx(46));
  secondFractionInternal($this$optional, 1, 9, Companion_getInstance().GROUP_BY_THREE_1);
  return Unit_instance;
}
function _get_ISO_TIME_OPTIONAL_SECONDS_TRAILING_ZEROS_$ref_fmwpvv() {
  return constructCallableReference(() => get_ISO_TIME_OPTIONAL_SECONDS_TRAILING_ZEROS(), 0, 0, 71);
}
var properties_initialized_LocalTime_kt_bt8uiw;
function _init_properties_LocalTime_kt__nmhi56() {
  if (!properties_initialized_LocalTime_kt_bt8uiw) {
    properties_initialized_LocalTime_kt_bt8uiw = true;
    ISO_TIME_OPTIONAL_SECONDS_TRAILING_ZEROS$delegate = lazy(ISO_TIME_OPTIONAL_SECONDS_TRAILING_ZEROS$delegate$lambda);
  }
}
//region block: init
Formats_instance = new (Formats())();
//endregion
//region block: exports
export {
  Companion_getInstance_0 as Companion_getInstance3qlladteis94,
  get_ISO_TIME_OPTIONAL_SECONDS_TRAILING_ZEROS as get_ISO_TIME_OPTIONAL_SECONDS_TRAILING_ZEROS1pgdef0x3xl4f,
  LocalTime as LocalTime22kisvxz6f9p4,
  atDate as atDatef446kt6vbj70,
};
//endregion

//# sourceMappingURL=LocalTime.mjs.map
